module.exports = __webpack_public_path__ + "static/media/robot-icon.03b43d50.png";